module.exports = __webpack_public_path__ + "img/v1_no3_p2.c4fd3996.jpg";